<template>
    <v-card hover raised class="text-xs-center card-scrollable">
        <v-card-title primary-title>
            <h3 class="headline mb-0">Mis actualizaciones</h3>
            <v-spacer></v-spacer>
            <slot name="opciones"></slot>
            <v-progress-linear height="2" :indeterminate="true" :active="loading"></v-progress-linear>
        </v-card-title>
        <v-card-text>
            <v-list two-line>
                <template v-for="p in presupuestos">
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>Presupuesto: <b>{{ p.presupuesto_id }}</b></v-list-tile-title>
                            <v-list-tile-sub-title class="text--primary">Item: <b>{{ p.id }}</b> | {{ p.item_tipo.desig }} | {{ (p.item)? p.item.descripcion : '' }}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>Actualizado: {{ p.updated_at | tiempo }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                </template>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
    import mixinPresup from '../../mixins/presupuesto';
    import moment from 'moment';

    moment.locale('es');
    export default {
        name: "misPresupuestos",
        mixins: [mixinPresup],
        filters: {
            tiempo(v) {
                return moment(v).fromNow();
            }
        },
        data() {
            return {
                loading: false,
                presupuestos: []
            }
        },
        mounted() {
            this.datos()
        },
        methods: {
            datos() {
                this.loading = true;
                this.presupuestoMios(r => {
                    this.presupuestos = r;
                    this.loading = false;
                }, err => console.log(err))
            }
        }
    }
</script>
<style scoped>
    .card-scrollable .v-card__text {
        overflow-y: auto;
        height: 300px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/misPresupuestos.vue